import { API_STREAMS, API_STREAMS_ADMIN, apiHeaders, q } from './apiAuth';

export const fetchStreaming = async (dashboard, token) => {
    try {
        const response = await fetch(`${API_STREAMS}/selectdashboardstreams/${'drillbi'}`, {
            method: "GET",
            headers: apiHeaders(),
        });
        return await response.json();

    } catch (error) {
        throw new Error("A ocurrido un error con la carga de informacion")
    }
}

export const getPathsFromStream = async (product, client, project, streamType, wellName) => {
    try {
        const response = await fetch(`${API_STREAMS}/selectstream/${product}/${client}/${project}/${streamType}/${wellName}`, {
            method: "GET",
            headers: apiHeaders(),
        });
        return await response.json();

    } catch (error) {
        throw new Error("A ocurrido un error con la carga de informacion")
    }
}

export const getStreamingStatus = async (product, client, project, streamType, wellName) => {
    try {
        const response = await fetch(`${API_STREAMS}/getstreamingstatus/${product}/${client}/${project}/${streamType}/${wellName}`, {
            method: "GET",
            headers: apiHeaders(),
        });
        return await response.json();

    } catch (error) {
        throw new Error("A ocurrido un error con la carga de informacion")
    }
}

export const getLogsStreaming = async (product, client, streamType, project, wellName, logType) => {
    try {
        const response = await fetch(`${API_STREAMS_ADMIN}/downloadlog/${product}/${client}/${project}/${streamType}/${wellName}?log_type=${q(logType)}`, {
            method: "GET",
            headers: apiHeaders(),
        });

        // Verificar si la respuesta es exitosa
        if (!response.ok) {
            const errorData = await response.json(); // Convertir a JSON si es necesario
            throw new Error(errorData.statusMessage || "An unknown error occurred");
        }

        // Convertir la respuesta a texto plano
        const logsText = await response.text();
        return logsText; // Retorna el contenido como texto
    } catch (error) {
        throw new Error(error.message || "An error occurred while fetching logs");
    }
};

// One stream's columns: its stream type config vs. its table (see streams_api_admin /streamcolumns)
export const getStreamColumns = async (product, client, project, streamType, wellName) => {
    const response = await fetch(`${API_STREAMS_ADMIN}/streamcolumns/${product}/${client}/${project}/${streamType}/${wellName}`, {
        method: "GET",
        headers: apiHeaders(),
    });
    return await response.json();
};
